import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Button, Row, Col } from "reactstrap";
import Layout from "../components/public/Layout";
import {
    FaGolfBall,
    FaClock,
    FaCalendarAlt,
    FaDollarSign,
} from "react-icons/fa";
import moment from "moment/moment";
import '@fontsource/poppins'; // Defaults to weight 400
import api from "../services/api";

const CancelPage = () => {
    const { guid } = useParams();
    const navigate = useNavigate();
    const [bookingData, setBookingData] = React.useState({});

    useEffect(() => {
        document.title = 'Reserve2Day';

        // Fetch the booking data
        api.get(`/get-booking/?event=${guid}`)
            .then((response) => {
                setBookingData(response.data);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [guid]);
    ;

    const handleCancel = () => {
        // Cancel the booking
        api.get(`/cancel-booking/?event=${guid}&email`)
            .then(() => {
                // Redirect to the main page
                navigate('/');
            })
            .catch((err) => {
                console.error(err);
            });
    };

    if (!bookingData || Object.keys(bookingData).length === 0) {
        return (
            <Layout>
                <Container className="text-center mt-5">
                    <h4 className="mb-5">No reservation found</h4>
                    <Button outline color="dark" onClick={() => navigate('/')}>Make Another Reservation</Button>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container className="d-flex flex-column gap-4 align-items-center mt-5">
                <Row>
                    <Col>
                        <h3>Reservation Details</h3>
                        <div className="d-flex flex-column gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <FaGolfBall />
                                <span>{bookingData.serviceDetails?.title || "Custom"}</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <FaClock />
                                <span>{moment(bookingData.start).format('MM/DD/YYYY')}</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <FaCalendarAlt />
                                <span>{moment(bookingData.start).local().format('h:mm a') || "Not set"}</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <FaDollarSign />
                                <span>{bookingData.price} (due at check in)</span>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <p>Are you sure you want to cancel your booking?</p>
                        <Button block color="danger" onClick={handleCancel}>Cancel Booking</Button>
                        <Button block outline color="secondary" className="mt-3" onClick={() => navigate('/')}>Go back</Button>

                    </Col>
                </Row>


            </Container>
        </Layout>
    );
}

export default CancelPage;
